function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#647A97",
  d: "M13.547 1.133a1.665 1.665 0 111.276 3.078l-2.897 1.08a.331.331 0 00-.182.163l-2.5 5a.663.663 0 01-.3.299l-1.806.903a.668.668 0 01-.922-.831L7.52 7.346a.164.164 0 00-.04-.178.165.165 0 00-.178-.035L3.557 8.632a.666.666 0 01-.718-.147L.342 5.988a.665.665 0 01.21-1.085l1.737-.744a.675.675 0 01.561.016l1.584.792a.335.335 0 00.282.008l8.826-3.842zM5.651.323a.675.675 0 01.511 0L9.687 1.78a.167.167 0 010 .307L6.92 3.29a.326.326 0 01-.26 0l-2.6-1.076a.666.666 0 010-1.231z"
});

function SvgHappyFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12"
  }, props), _ref);
}

export default SvgHappyFlight;